import { render, staticRenderFns } from "./DatasetAdd.vue?vue&type=template&id=186dbc1a&"
import script from "./DatasetAdd.vue?vue&type=script&lang=js&"
export * from "./DatasetAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports